export default __webpack_public_path__ + "static/media/ai-icon2.765c3ce0.png";